module.exports = __webpack_public_path__ + "img/vegetable-brussels-sprouts-190x100.3f592c89.jpg";